<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="detail" v-loading="loading">
    <scroll-parallax class="parallax head-bg" :speed="0.4" :down="true">
      <img
        v-if="matchDetail && matchDetail.match.webBackground"
        class="bg md:h-[100vh] object-contain"
        :src="matchDetail.match.webBackground"
        alt=""
      />
      <!--      <img v-else class="bg" :src="require('../../../assets/web/ces3.png')" alt="">-->
    </scroll-parallax>

    <div class="shop-content" v-if="matchDetail && matchDetail.match">
      <div
        class="top"
        v-motion
        :initial="visibleTransitionInit"
        :visible-once="visibleTransitionOnce"
      >
        <p>Events</p>
        <p>{{ matchDetail.match.name }}</p>
        <p>
          <span>{{ matchDetail.match.displayTime }}</span> &bull;
          <span>£ {{ matchDetail.match.fee }}</span> &bull;
          <span>Hosted by Sidequest</span>
        </p>
        <div
          class="btn"
          @click="handleJoin"
          v-if="
            new Date().valueOf() <
              new Date(matchDetail.match.checkin).valueOf() &&
            matchDetail.match.type != 1 &&
            !joinData.isJoin
          "
        >
          Join
        </div>
        <div
          class="flex"
          v-if="
            new Date().valueOf() <
              new Date(matchDetail.match.checkin).valueOf() &&
            matchDetail.match.type == 1 &&
            !joinData.isJoin
          "
        >
          <div class="btn" style="margin-right: 10px" @click="handleJoin(1)">
            Join Team
          </div>
          <div class="btn" @click="handleJoin(2)">create Team</div>
        </div>
        <div
          v-if="matchDetail.match.type == 1 && joinData.isJoin"
          style="font-weight: bolder; margin-top: 10px"
        >
          Team PassCode: <span>{{ joinData.passCode }}</span>
          <el-button
            @click="copyCode"
            style="
              margin-left: 20px;
              background: #ffb20e;
              border: none;
              color: #000000;
            "
          >
            copy
          </el-button>
        </div>
        <div
          class="btn"
          v-if="
            new Date().valueOf() > new Date(matchDetail.match.checkin).valueOf()
          "
        >
          COMPLETED
        </div>
      </div>

      <el-tabs
        v-model="activeName"
        class="tabs"
        @tab-change="handleTabsChange($event)"
      >
        <el-tab-pane :label="language ? '概述' : 'Overview'" name="Overview">
          <overview></overview>
        </el-tab-pane>
        <!--        <el-tab-pane label="Bracket" name="Bracket">Config</el-tab-pane>-->
        <el-tab-pane
          v-if="matchDetail.match.rules"
          :label="language ? '规则' : 'Rules'" 
          name="Rules">
          <div
            v-if="!language"
            style="color: #ffffff; font-size: 16px; padding: 20px 0 40px"
            v-html="matchDetail.match.rules"
          ></div>
          <div
            v-else
            style="color: #ffffff; font-size: 16px; padding: 20px 0 40px"
            v-html="matchDetail.match['rules' + language]"
          ></div>
        </el-tab-pane>
        <el-tab-pane 
          v-if="treeData.length"
          :label="language ? '比赛' : 'Matches'" 
          name="Matches">
          <div
            class="tree-item"
            :style="{ minHeight: height + 'px' }"
            v-if="activeName === 'Matches'"
          >
            <div class="tree-item-content" v-if="treeData.length">
              <tree-item
                :tree-data="treeData"
                :tree-first="true"
                :isRight="true"
              />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="language ? 'Sidekick注册成员' : 'Players'"
          name="Players"
          v-if="matchDetail.match.type != 1"
        >
          <players></players>
        </el-tab-pane>
        <el-tab-pane label="Teams" name="Teams" v-else>
          <teams
            @handleCreateTeam="handleJoin(2)"
            @handleJoinTeam="handleJoinTeam($event)"
          ></teams>
        </el-tab-pane>

        <el-tab-pane 
          v-if="matchDetail.match.prize.name"
          :label="language ? '总奖池' : 'Prizes'" 
          name="Prizes">
          <div
            style="color: #ffffff; padding: 50px 0 70px; font-size: 16px"
            v-if="matchDetail.match.prize.indexOf('<p') !== -1"
            v-html="matchDetail.match.prize"
          ></div>
          <div class="prize-content" v-else>
            <div
              style="justify-content: flex-start"
              class="prize-item"
              v-for="item in JSON.parse(matchDetail.match.prize)"
              :key="item.uk"
            >
              <!--              <div class="rank">-->
              <!--                <img :src="require('@/assets/web/tournaments/ranking'+item.name+'.png')" alt="">-->
              <!--                <p>{{item.name}}</p>-->
              <!--              </div>-->
              <!--              <p>{{item.value}}</p>-->
              <!--              <div class="user" v-if="item.avatar">-->
              <!--                <img :src="item.avatar" alt="">-->
              <!--                <p>{{item.nickname}}</p>-->
              <!--              </div>-->
              <!--              <div v-else>待定</div>-->

              <img
                v-if="item.avatar"
                style="
                  width: 80px;
                  height: 80px;
                  border-radius: 50%;
                  margin-right: 20px;
                "
                :src="item.avatar"
                alt=""
              />
              <img
                v-else
                style="
                  width: 80px;
                  height: 80px;
                  border-radius: 50%;
                  margin-right: 20px;
                "
                src="@/assets/head.png"
                alt=""
              />
              <div>
                <p>{{ item.nickname }}</p>
                <div class="rank" style="padding: 10px 0">
                  <img
                    v-if="item.name.includes('1st')"
                    src="@/assets/web/tournaments/ranking1st.png"
                    alt=""
                  />
                  <img
                    v-else-if="item.name.includes('2nd')"
                    src="@/assets/web/tournaments/ranking2nd.png"
                    alt=""
                  />
                  <img
                    v-else-if="item.name.includes('3th')"
                    src="@/assets/web/tournaments/ranking3td.png"
                    alt=""
                  />
                  <p>{{ item.name }}</p>
                </div>
                <p>{{ item.value }}</p>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <!--        <el-tab-pane :label="language?'社区':'Community'" name="Community" v-if="timLoginStatus">-->
        <!--          <community v-if="groupId && activeName=='Community'"></community>-->
        <!--        </el-tab-pane>-->
      </el-tabs>
    </div>

    <el-dialog
      v-model="dialogVisible"
      width="500px"
      :before-close="handleClose"
      center
      title="Join"
    >
      <div class="content" v-if="matchDetail && matchDetail.match">
        <div class="selected">
          <p>Location :</p>
          <el-select v-model="storeId">
            <el-option
              v-for="(item, index) in JSON.parse(matchDetail.match.locations)"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="selected" v-if="matchDetail.match.matchDiff === 5">
          <p>Time :</p>
          <el-time-select
            v-model="date"
            class="mr-4"
            placeholder="Time"
            :start="toSelectDate(matchDetail.match.happenTime)"
            :end="toSelectDate(matchDetail.match.checkin)"
            :step="toSelectStep(matchDetail.match.stepLength)"
            @change="dateChange"
          />
          <span style="padding: 0 4px">-</span>
          <el-time-picker
            v-model="endDate"
            format="HH:mm"
            value-format="HH:mm"
            disabled
          />
        </div>
        <div
          class="selected"
          v-if="matchDetail.match && matchDetail.match.fee > 0"
        >
          <p>Vouchers :</p>
          <el-select v-model="couponId" @change="eventCouponChange()">
            <el-option
              v-for="(item, index) in eventCoupons"
              :key="index"
              :label="item.coupon.name + ' - £' + item.coupon.creditDiscount"
              :value="item.id"
            >
              <div class="coupon-option">
                <p>{{ item.coupon.name }}</p>
                <p>£{{ item.coupon.creditDiscount }}</p>
              </div>
            </el-option>
          </el-select>
        </div>

        <div style="font-size: 14px">
          We will charge a deposit of
          <span :class="matchFee > 0 ? 'has-discount' : ''">
            £ {{ matchDetail.match.fee }}</span
          ><span v-if="matchFee > 0"> £ {{ matchFee.toFixed(1) }}</span> from
          your balance for this sign up.
        </div>
        <el-checkbox v-model="checked"
          >By signing up to SideQuest's tournament, <br />you agree to our
          Tournament Rules and
          <span
            ><a
              href="/static/pdfjs/web/viewer.html?file=/static/policy/SideQuest-VIPupgrade.pdf"
              target="_blank"
              style="color: #fff833"
              >Terms&Conditions</a
            ></span
          ></el-checkbox
        >
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="handleAffirm">OK</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog
      v-model="showDiaPop"
      width="500px"
      :before-close="handleClose"
      center
      title="Join"
    >
      <div class="content" v-if="matchDetail && matchDetail.match">
        <div class="selected">
          <p>Location :</p>
          <el-select v-model="formData.location" style="width: 100%">
            <el-option
              v-for="(item, index) in JSON.parse(matchDetail.match.locations)"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div>
        <div
          class="selected"
          v-if="matchDetail.match && matchDetail.match.fee > 0"
        >
          <p>Vouchers :</p>
          <el-select
            v-model="formData.couponId"
            @change="eventCouponChange()"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in eventCoupons"
              :key="index"
              :label="item.coupon.name + ' - £' + item.coupon.creditDiscount"
              :value="item.id"
            >
              <div class="coupon-option">
                <p>{{ item.coupon.name }}</p>
                <p>£{{ item.coupon.creditDiscount }}</p>
              </div>
            </el-option>
          </el-select>
        </div>

        <div style="font-size: 14px">
          We will charge a deposit of
          <span :class="matchFee > 0 ? 'has-discount' : ''">
            £ {{ matchDetail.match.fee }}</span
          ><span v-if="matchFee > 0"> £ {{ matchFee.toFixed(1) }}</span> from
          your balance for this sign up.
        </div>
        <el-checkbox v-model="checked"
          >By signing up to SideQuest's tournament, <br />you agree to our
          Tournament Rules and
          <span
            ><a
              href="/static/pdfjs/web/viewer.html?file=/static/policy/SideQuest-VIPupgrade.pdf"
              target="_blank"
              style="color: #fff833"
              >Terms&Conditions</a
            ></span
          ></el-checkbox
        >
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="handleNextStep">OK</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog
      v-model="joinDialogVisible"
      width="500px"
      :before-close="handleClose"
      center
      title="Join a team"
      class="team-pop"
    >
      <div class="content team">
        <img v-if="teamAvatar" class="avatar" :src="teamAvatar" alt="" />
        <p v-if="teamName" class="name">{{ teamName }}</p>
        <div class="selected">
          <p>TEAM PASSCODE</p>
          <el-input
            v-model="formData.code"
            placeholder="input your team passcode"
          />
        </div>
        <div class="selected">
          <p>PLAYING ROLE</p>
          <el-input
            v-model="formData.role"
            placeholder="input your playing role"
          />
        </div>
        <div class="selected">
          <p>DISCORD TAG</p>
          <el-input
            v-model="formData.discordTag"
            placeholder="input your discord tag"
          />
        </div>
      </div>
      <div style="font-size: 14px">
        We will charge a deposit of
        <span :class="matchFee > 0 ? 'has-discount' : ''">
          £ {{ matchDetail.match.fee }}</span
        ><span v-if="matchFee > 0"> £ {{ matchFee.toFixed(1) }}</span> from your
        balance for this sign up.
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="handleJoinAffirm">Submit</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog
      v-model="createDialogVisible"
      width="500px"
      :before-close="handleClose"
      center
      title=""
      class="team-pop"
    >
      <div class="content team">
        <img class="avatar" :src="userData.memberPhoto" alt="" />
        <div class="selected">
          <p>TEAM NAME</p>
          <el-input
            v-model="formData.name"
            placeholder="input your team name"
          />
        </div>
        <div class="selected">
          <p>PLAYING ROLE</p>
          <el-input
            v-model="formData.role"
            placeholder="input your playing role"
          />
        </div>
        <div class="selected">
          <p>DISCORD TAG</p>
          <el-input
            v-model="formData.discordTag"
            placeholder="input your discord tag"
          />
        </div>
      </div>
      <div style="font-size: 14px">
        We will charge a deposit of
        <span :class="matchFee > 0 ? 'has-discount' : ''">
          £ {{ matchDetail.match.fee }}</span
        ><span v-if="matchFee > 0"> £ {{ matchFee.toFixed(1) }}</span> from your
        balance for this sign up.
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="handleCreateAffirm"
            >Submit</el-button
          >
        </span>
      </template>
    </el-dialog>

    <riot
      v-if="showRiotDialogVisible"
      @close="handleClose"
      @selected="handleNext($event)"
    ></riot>
  </div>
</template>

<script setup>
import {
  computed,
  nextTick,
  onMounted,
  provide,
  reactive,
  ref,
  watch,
} from "vue";
import Overview from "@/components/web/tournaments/overview";
import players from "@/components/web/tournaments/players.vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import moment from "moment";
import TreeItem from "@/components/web/tournaments/tree-item.vue";
import { joinGroup } from "@/utils/tim";
import useClipboard from "vue-clipboard3";
import { ElMessage } from "element-plus";
import { joinTeam } from "@/store/activities/actions";
import Teams from "@/components/web/tournaments/teams.vue";
import Riot from "@/views/riot/riot.vue";

const visibleTransitionInit = { opacity: 0, y: 100 };
const visibleTransitionOnce = {
  opacity: 1,
  y: 0,
  transition: {
    type: "spring",
    stiffness: 250,
    damping: 25,
    mass: 0.5,
  },
};
const tabVisibleTransitionInit = { x: 100 };
const tabVisibleTransitionOnce = {
  x: 0,
  transition: {
    type: "spring",
    stiffness: 250,
    damping: 25,
    mass: 0.5,
  },
};

const activeName = ref("Overview");
const store = useStore();
const route = useRoute();
const treeData = reactive([]);
const height = ref("");
provide("height", height);
const code = ref("");
const loading = ref(false);
const teamAvatar = ref("");
const teamName = ref("");

const formData = ref({
  code: "",
  role: "",
  discordTag: "",
  name: "",
  couponId: "",
  location: "",
});

store.dispatch("activities/getWebMatchDetail", route.params.id).then((res) => {
  loading.value = false;
});

const matchDetail = computed(() => store.state.activities.matchDetail);
const userData = computed(() => store.state.user.userData);
const timLoginStatus = computed(() => store.state.user.loginStatus);
provide("matchDetail", matchDetail); // 传值
const JoinDialogVisible = ref(false);
const dialogVisible = ref(false);
const showDiaPop = ref(false);
const joinDialogVisible = ref(false);
const createDialogVisible = ref(false);
const showRiotDialogVisible = ref(false);
const joinData = ref({
  isJoin: false,
  passCode: "",
});
provide("joinData", joinData); // 传值
const checked = ref(true);
const storeId = ref("");
const date = ref("");
const endDate = ref("");
const cupSleeve = ref("");
var zeroize = function (value, length) {
  if (!length) {
    length = 2;
  }
  value = new String(value);
  for (var i = 0, zeros = ""; i < length - value.length; i++) {
    zeros += "0";
  }
  return zeros + value;
};

watch(
  matchDetail,
  (val) => {
    if (val && val.match) {
      storeId.value =
        JSON.parse(val.match.locations).length === 1
          ? JSON.parse(val.match.locations)[0].id
          : "";
      if (val.match.groupId) {
        joinGroup(val.match.groupId);
        groupId.value = val.match.groupId;
      }
    }
  },
  { immediate: true },
);

const eventCoupons = ref([]);
const couponId = ref("");
const matchFee = ref(0);
const groupId = ref("");
provide("groupId", groupId);

const language = ref("");
onMounted(() => {
  getJoinMatch();
  language.value = getQueryVariable().language;
  if (getQueryVariable().type == "joinRitoSuccess") {
    showRiotDialogVisible.value = true;
  }
});

//是否加入比赛
const getJoinMatch = () => {
  store
    .dispatch("activities/getMatchPersonal", { matchId: route.params.id })
    .then((res) => {
      joinData.value = res;
      if (getQueryVariable().passCode && !res.isJoin) {
        joinDialogVisible.value = true;
        formData.value.code = getQueryVariable().passCode;
      }
    });
};

/**
 * 加入比赛弹窗
 */
// const router = useRouter()
// const authDialogVisible = ref(false)
// const authList = ref([])
let clickNum = 1;
const handleJoin = (num, data) => {
  if (getQueryVariable().source === "fans" && !userData.value) {
    // iframe 通知登录
    window.parent.postMessage("login", "*");
    return;
  }

  if (!userData.value) {
    store.dispatch("http/setLoginState", true);
    return;
  }

  clickNum = num;

  if (matchDetail.value.match.company == "Riot") {
    showRiotDialogVisible.value = true;
    return;
  }

  store.dispatch("activities/getEventCoupons").then((res) => {
    eventCoupons.value = res;
  });
  if (matchDetail.value.match.type == 1) {
    if (
      !matchDetail.value.match.locations ||
      (matchDetail.value.match.locations &&
        JSON.parse(matchDetail.value.match.locations).length <= 1)
    ) {
      formData.value.location = matchDetail.value.match.location;
    }
		if(num != 1){
			showDiaPop.value = true;
		}else {
			joinDialogVisible.value = true;
		}
  } else {
    dialogVisible.value = true;
  }
};
const selectedRiotAccount = ref("");
const handleNext = (data) => {
  showRiotDialogVisible.value = false;
  selectedRiotAccount.value = data.puuid;
  if (matchDetail.value.match.type == 1) {
    showDiaPop.value = true;
  } else {
    dialogVisible.value = true;
  }
};

const handleJoinTeam = (data) => {
  handleJoin(1, data);
};

const handleNextStep = () => {
  showDiaPop.value = false;
  if (clickNum === 1) {
    joinDialogVisible.value = true;
  } else {
    createDialogVisible.value = true;
  }
};

/**
 * 添加授权
 */
// const addAuth = () => {
//   const demo = window.open(router.resolve({path: '/riot-auth'}).href,'_blank','width=500,height=800,menubar=no,toolbar=no, status=no,scrollbars=yes')
//   const time = setInterval(() => {
//     if (demo.closed) {
//       clearInterval(time)
//       getAuthList()
//     }
//   }, 500)
// }

/**
 * 获取授权列表
 * @returns {{}}
 */
// const getAuthList = () => {
//   store.dispatch('user/getAuthList')
//       .then(res => {
//         if (res) {
//           authList.value = res
//         }
//       })
// }

const getQueryVariable = () => {
  let href = window.location.href;
  let query = href.substring(href.indexOf("?") + 1);
  let vars = query.split("&");
  let obj = {};
  for (var i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    obj[pair[0]] = pair[1];
  }
  return obj;
};
/**
 * 关闭确认弹窗
 */
const handleClose = () => {
  dialogVisible.value = false;
  showDiaPop.value = false;
  joinDialogVisible.value = false;
  createDialogVisible.value = false;
  showRiotDialogVisible.value = false;
};

const toSelectDate = (date) => {
  if (date != undefined && date != null && date.length > 0) {
    return (
      zeroize(new Date(date).getHours()) +
      ":" +
      zeroize(new Date(date).getMinutes())
    );
  }
  return "";
};
const toSelectStep = (step) => {
  if (step != undefined && step != null && step > 0) {
    return "00:" + zeroize(step);
  }
  return "00:15";
};

/**
 * 选择优惠券
 */
const eventCouponChange = () => {
  if (couponId.value) {
    store
      .dispatch("activities/selectCoupon", {
        couponId: couponId.value || formData.value.couponId,
        matchId: matchDetail.value.match.id,
      })
      .then((res) => {
        if (res) {
          matchFee.value = res.total;
        }
      });
  }
};

/**
 * 比赛确认弹窗
 */
const handleAffirm = () => {
  if (!checked.value) {
    store.dispatch("http/setHttpState", {
      msg: "You have to agree Terms&Condition first before join the event!",
      dialogVisible: true,
      state: false,
    });
    return;
  }
  if (
    storeId.value === "" &&
    matchDetail.value.match.matchDiff !== 6 &&
    dialogVisible.value
  ) {
    store.dispatch("http/setHttpState", {
      msg: "location is required",
      dialogVisible: true,
      state: false,
    });
    return;
  }
  if (
    !cupSleeve.value &&
    matchDetail.value.match.matchDiff === 5 &&
    dialogVisible.value
  ) {
    store.dispatch("http/setHttpState", {
      msg: "Time is required",
      dialogVisible: true,
      state: false,
    });
    return;
  }
  store
    .dispatch("activities/joinMatch", {
      checked: true,
      location: matchDetail.value.match.matchDiff === 5 ? 5 : storeId.value,
      matchId: matchDetail.value.match.id,
      cupsleeve: cupSleeve.value,
      couponId: couponId.value,
      gameAccount:
        matchDetail.value.match.company == "Riot"
          ? selectedRiotAccount.value
          : "",
    })
    .then((res) => {
      if (res) {
        handleClose();
        getJoinMatch();
        store.dispatch("http/setHttpState", {
          msg: "Congratulations! Be Prepared! </br> You have successfully joined this event!",
          dialogVisible: true,
          state: true,
        });
        store.dispatch("activities/getWebMatchDetail", route.params.id);
      }
    });
};

/** 加入队伍 */
const handleJoinAffirm = () => {
  if (!formData.value.code) {
    store.dispatch("http/setHttpState", {
      msg: "Team Password is required",
      dialogVisible: true,
      state: false,
    });
    return;
  }
  if (!formData.value.role) {
    store.dispatch("http/setHttpState", {
      msg: "Playing Role is required",
      dialogVisible: true,
      state: false,
    });
    return;
  }
  if (!formData.value.discordTag) {
    store.dispatch("http/setHttpState", {
      msg: "Discord Tag is required",
      dialogVisible: true,
      state: false,
    });
    return;
  }
  store
    .dispatch("activities/joinTeam", {
      code: formData.value.code,
      role: formData.value.role,
      discordTag: formData.value.discordTag,
      matchId: matchDetail.value.match.id,
      gameAccount:
        matchDetail.value.match.company == "Riot"
          ? selectedRiotAccount.value
          : "",
	    location: formData.value.location,
    })
    .then((res) => {
      if (res) {
        dialogVisible.value = false;
        JoinDialogVisible.value = false;
        store.dispatch("http/setHttpState", {
          msg: "Congratulations! Be Prepared! </br> You have successfully joined this event!",
          dialogVisible: true,
          state: true,
        });
        handleClose();
        getJoinMatch();
      }
    });
};
/** 加入队伍 */
const handleCreateAffirm = () => {
  if (!formData.value.name) {
    store.dispatch("http/setHttpState", {
      msg: "Team Name is required",
      dialogVisible: true,
      state: false,
    });
    return;
  }
  if (!formData.value.role) {
    store.dispatch("http/setHttpState", {
      msg: "Playing Role is required",
      dialogVisible: true,
      state: false,
    });
    return;
  }
  if (
    !formData.value.location &&
    matchDetail.value.match.locations &&
    JSON.parse(matchDetail.value.match.locations).length > 1
  ) {
    store.dispatch("http/setHttpState", {
      msg: "location is required",
      dialogVisible: true,
      state: false,
    });
    return;
  }
  if (!formData.value.discordTag) {
    store.dispatch("http/setHttpState", {
      msg: "Discord Tag is required",
      dialogVisible: true,
      state: false,
    });
    return;
  }
  // 随机生成6位code
  let code = "";
  for (let i = 0; i < 6; i++) {
    code += Math.floor(Math.random() * 10);
  }
  store
    .dispatch("activities/createTeam", {
      code: code,
      role: formData.value.role,
      discordTag: formData.value.discordTag,
      matchId: matchDetail.value.match.id,
      name: formData.value.name,
      gameAccount:
        matchDetail.value.match.company == "Riot"
          ? selectedRiotAccount.value
          : "",
      location: formData.value.location,
    })
    .then((res) => {
      if (res) {
        store.dispatch("http/setHttpState", {
          msg: "Congratulations! Be Prepared! </br> You have successfully joined this event!",
          dialogVisible: true,
          state: true,
        });
        handleClose();
        getJoinMatch();
      }
    });
};

/**
 * 时间选择
 * @param v
 */
const dateChange = (v) => {
  if (v) {
    let time = matchDetail.value.match.happenTime;
    let happenTime = moment(time).format("YYYY-MM-DD");
    let start = happenTime + " " + date.value;
    let newStart = new Date(start);
    let time1 = newStart.setMinutes(newStart.getMinutes() + 15);
    endDate.value = moment(new Date(time1)).format("HH:mm DD/MM/YYYY");
    cupSleeve.value = start;
  } else {
    endDate.value = "";
    cupSleeve.value = "";
  }
};

const handleTabsChange = (v) => {
  if (v === "Matches") {
    store
      .dispatch("activities/getMatchTree", {
        matchId: matchDetail.value.match.id,
      })
      .then((res) => {
        if (res) {
          treeData.length = 0;
          treeData.push(res);
        }
      });
  }
};

const { toClipboard } = useClipboard();
const copyCode = async () => {
  try {
    await toClipboard(location.href + "?passCode=" + joinData.value.passCode);
    ElMessage({
      message: "Copied successfully!",
      type: "success",
    });
  } catch (e) {
    ElMessage({
      message: "Copied failed!",
      type: "success",
    });
  }
};
</script>

<style scoped lang="scss">
@use "@/styles/base" as *;

.detail {
  background: #0f1317;
  text-align: left;

  .flex {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .head-bg {
    position: relative;

    &:before {
      content: "";
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      top: 0;
      left: 0;
      z-index: 3;
    }
  }

  .bg {
    width: 100%;
  }

  :deep(.shop-content) {
    margin-top: -24vw;
    padding: 0 6.58vw;
    position: relative;
    z-index: 3;

    @include media("<tablet") {
      margin-top: 24px;
    }

    .top {
      font-size: 18px;
      color: #ffffff;

      p:first-child {
        color: #979dad;
      }

      p:nth-child(2) {
        font-size: 50px;
        padding: 20px 0;
      }

      .btn {
        width: 132px;
        height: 28px;
        background: #ffb20e;
        border-radius: 14px;
        font-size: 14px;
        color: #000000;
        margin: 30px 0;
        line-height: 28px;
        text-align: center;
        cursor: pointer;
      }

      .code {
        width: 100%;
        margin-top: 30px;
        line-height: 40px;

        p {
          color: #ffffff;
        }

        a {
          color: #0a84ff;
        }
      }
    }

    .tabs {
      padding-top: 70px;

      @include media("<phone") {
        padding-top: 24px;
      }

      .el-tabs__item {
        color: #9aa0b0;
        font-size: 20px;
        height: 50px;
      }

      .flex-center-center {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .tree-item {
        position: relative;
        min-height: 1300px;

        .tree-item-content {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(90deg);
        }
      }

      .el-tabs__nav-next,
      .el-tabs__nav-prev {
        display: flex;
        width: 24px;
        height: 100%;

        .el-icon {
          width: unset;
          height: unset;

          svg {
            width: 24px;
            height: 24px;
          }
        }
      }

      .is-active {
        color: #ffffff;
      }

      .el-tabs__item:hover {
        color: #ffffff;
      }

      .prize-content {
        padding: 50px 0 70px;
      }

      .prize-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #ffffff;
        font-size: 16px;
        border-bottom: 1px solid #b4b4b4;
        margin-bottom: 20px;
        padding: 0 30px 20px;

        .rank {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          img {
            width: 40px;
            margin-right: 20px;
          }
        }

        .user {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          width: 180px;

          img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            object-fit: cover;
            margin-right: 10px;
          }
        }
      }
    }
  }
}

:deep(.team-pop) {
  .el-input__inner {
    color: #ffffff !important;
  }
}

:deep(.el-dialog) {
  background: #1c1f24;
  border-radius: 14px;
  padding-bottom: 20px;
  min-width: 460px;

  @include media("<phone") {
    min-width: unset;
    width: 90vw;
  }

  .el-dialog__title {
    color: #ffffff;
  }

  .el-dialog__body {
    padding-top: 10px;
  }

  .content {
    @include text-xl;
    text-align: left !important;
    color: #ffffff;
    padding-top: 20px;

    .el-checkbox {
      margin-top: 10px;

      @include media("<phone") {
        height: fit-content;
      }
    }

    .el-checkbox__label {
      display: block;
      word-break: break-all;
      width: 300px;
      line-height: 24px;

      @include media("<phone") {
        display: flex;
        flex-direction: column;
      }
    }

    .input {
      .el-input {
        width: 230px !important;
      }

      p {
        width: 160px !important;
      }
    }

    .selected {
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;

      @include media("<phone") {
        flex-direction: column;
        gap: 12px;
      }

      p {
        @include text-base;
        margin-right: 10px;
        width: 100px;
      }
    }

    img {
      width: 80px;
      padding-bottom: 20px;
    }

    span {
      color: rgb(255, 248, 51);
    }

    .has-discount {
      color: #ff3131;
      text-decoration: line-through;
    }
  }

  .team {
    .avatar {
      margin: 0 auto 16px;
      width: 87px;
      height: 87px;
      border-radius: 50%;
      padding-bottom: 0;
    }

    .name {
      text-align: center;
    }

    .selected {
      display: block;
      margin-bottom: 24px;

      @include media("<phone") {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }

      .el-input {
        width: 100%;

        .el-input__wrapper {
          border: 1px solid #cbd0e4;
          border-radius: 8px 8px 8px 8px;
        }

        .el-input__wrapper,
        .el-input__inner {
          background: none;
          height: 48px;
          line-height: 48px;
        }
      }

      p {
        width: 160px;
        // 禁止换行
        white-space: nowrap;
        color: #9aa0b0;
        margin-bottom: 16px;
      }
    }
  }

  .dialog-footer {
    .el-button {
      width: 120px;
      background: #ffae0e;
      color: #ffffff;
    }
  }
}
</style>
